import React from 'react';
import Header from './common/Header';
import Footer from './common/Footer';

const TermsOfUsePage = () => {
  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <Header />
      
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        {/* Hero Section */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4 bg-gradient-to-r from-teal-400 to-green-400 bg-clip-text text-transparent">
            Terms of Use
          </h1>
          <p className="text-gray-400">
            Last updated: February 23, 2024
          </p>
        </div>

        {/* Content */}
        <div className="prose prose-lg prose-invert max-w-none">
          
          {/* Introduction */}
          <section className="mb-12">
            <div className="bg-gray-800 rounded-lg p-8 border border-gray-700 mb-8">
              <p className="text-gray-300 leading-relaxed mb-4">
                Please carefully read these terms and conditions before using this website (the "Site"). By accessing or using the Site, you ("user") agree to be legally bound by these terms and conditions. If you disagree with any of the following terms or conditions, please do not use this site.
              </p>
              <p className="text-gray-300 leading-relaxed">
                Dotstudioz INC owns ChillFree TV and operates this Site. ChillFree TV reserves the right to change any terms or conditions without notice, effective upon their posting.
              </p>
            </div>
          </section>

          {/* Ownership of Intellectual Property Rights */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-6 text-teal-400">Ownership of Intellectual Property Rights</h2>
            <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
              <p className="text-gray-300 leading-relaxed mb-4">
                All text, photographs, images, illustrations, artwork, audio and video clips, design, software, graphic material, trademarks, service marks and trade names, and all intellectual property rights in and to such items (hereinafter "Content"), including any modifications, variation and/or derivative works thereof, constitute the sole and exclusive property of ChillFree TV or its subsidiaries, affiliates, licensors and content providers.
              </p>
              <p className="text-gray-300 leading-relaxed">
                ChillFree TV is a trademark of Dotstudioz INC. All rights reserved. All other trademarks and service marks are the property of their respective owners.
              </p>
            </div>
          </section>

          {/* Limitation of Liability and Disclaimers */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-6 text-teal-400">Limitation of Liability and Disclaimers</h2>
            <div className="bg-red-900/20 border border-red-500/30 rounded-lg p-6">
              <p className="text-gray-300 leading-relaxed font-semibold mb-4">
                USER EXPRESSLY AGREES THAT USE OF THE SITE IS AT USER'S SOLE RISK.
              </p>
              <p className="text-gray-300 leading-relaxed">
                NEITHER ChillFree TV, ITS PARENTS, AFFILIATES, EMPLOYEES, AGENTS, SERVICE PROVIDERS, THIRD PARTY INFORMATION PROVIDERS, LICENSORS OR THE LIKE, WARRANT THAT THE SITE WILL BE UNINTERRUPTED OR ERROR FREE; NOR DO THEY MAKE ANY WARRANTY AS TO THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE SITE, OR AS TO THE ACCURACY, RELIABILITY OR CONTENT OF ANY INFORMATION OR SERVICE CONTAINED IN OR PROVIDED THROUGH THE SITE.
              </p>
            </div>
          </section>

          {/* Third Party Links and Sites */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-6 text-teal-400">Third Party Links and Sites</h2>
            <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
              <p className="text-gray-300 leading-relaxed">
                This site may contain links to other Internet sites, resources and/or sponsors of the Site. ChillFree TV does not verify, warrant, endorse, or take responsibility for the availability, accuracy, completeness or quality of the content contained in these outside sites. Providing links to outside sites does not constitute ChillFree TV's approval of the content, policies or practices of those other sites. Be sure to review the terms of use and privacy policies posted on the outside sites after linking to them.
              </p>
            </div>
          </section>

          {/* User Submissions */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-6 text-teal-400">User Submissions</h2>
            <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
              <p className="text-gray-300 leading-relaxed mb-4">
                By posting or submitting material to this page ("Submission"), you grant to ChillFree TV a perpetual, non-exclusive, irrevocable, fully-paid and royalty-free worldwide right and license in any and all media now known or later developed, to use, publish, reproduce, display, modify, transmit digitally, create derivative works based upon and otherwise exploit such Submission (including, without limitation, any names, voices, likenesses, performances and actions contained therein) for any purpose whatsoever (including, without limitation, advertising, commercial, promotional and publicity purposes) in ChillFree TV's discretion without additional notice, attribution or consideration to you or to any other person or entity.
              </p>
              <p className="text-gray-300 leading-relaxed mb-4">
                Additionally, you certify that you are the original author or creator of your Submission (except as expressly indicated otherwise), that neither the permission nor consent of any other person or entity is required to enable ChillFree TV to legally use your Submission in accordance with this license, and that ChillFree TV's use of your Submission in accordance with this license will not violate or infringe upon the rights of any person or entity.
              </p>
              <p className="text-gray-300 leading-relaxed">
                You agree to forever release and discharge ChillFree TV and its licensees from any and all claims you may have in connection with ChillFree TV's use of your Submission in accordance with this license.
              </p>
            </div>
          </section>

          {/* Collection and Cookies */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-6 text-teal-400">Collection and Cookies</h2>
            <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
              <p className="text-gray-300 leading-relaxed mb-4">
                ChillFree TV collects personally identifiable information. The types of personally identifiable information ChillFree TV collects include: e-mail address, full name, full address and work, cell, and home phone numbers. When we collect information from you it is because you are voluntarily submitting the information to us in order to participate in activities like surveys, forums, content or suggestions you submit to us, chats or bulletin boards, or because you want us to furnish you with products, services or information.
              </p>
              <p className="text-gray-300 leading-relaxed mb-4">
                On occasion, ChillFree TV may use cookies to relate your use of the Site to personally identifiable information you have submitted to us. Cookies are small bits of information that Internet sites place on the hard drive of your computer. For example, if you've asked us to send you information about our upcoming programming, cookie information may allow us to limit the materials we send you to items we know you will find interesting, based on your prior online activities.
              </p>
              <p className="text-gray-300 leading-relaxed">
                Additionally, third party advertisements displayed on the Site may also contain cookies. As ChillFree TV does not control these advertiser cookies and visitors to the Site, you should check the privacy policy of the advertiser to see whether and how it uses cookies. Additionally, you can program your computer to warn you each time that a cookie is being sent or to refuse cookies completely.
              </p>
            </div>
          </section>

          {/* Use of Your Information */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-6 text-teal-400">Use of Your Information</h2>
            <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
              <p className="text-gray-300 leading-relaxed mb-4">
                ChillFree TV will use your information in a manner that is consistent with this Policy and only for the purpose for which it is submitted, unless other uses are disclosed at the time of collection and you allow us to use your information in these other ways. ChillFree TV may share your information with affiliated and unaffiliated companies who would like to send you information about their products and services. However, you will always have the opportunity to instruct us not to share your information with third parties.
              </p>
              <p className="text-gray-300 leading-relaxed">
                ChillFree TV employees, agents and contractors must have a legitimate business reason to obtain access to your information. Outside contractors or agents who help us manage our information activities may only use your information to provide us with a specific service and not for any other purpose. ChillFree TV may be required to disclose information to comply with legal requirements, such as a court order, and to protect the safety and security of visitors to the Site.
              </p>
            </div>
          </section>

          {/* Security */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-6 text-teal-400">Security</h2>
            <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
              <p className="text-gray-300 leading-relaxed">
                ChillFree TV uses reasonable administrative, technical, personnel and physical measures to safeguard information in its possession against loss, theft and unauthorized use, disclosure or modification. In addition, ChillFree TV uses reasonable methods to make sure that information is accurate and complete.
              </p>
            </div>
          </section>

          {/* E-Mail Removal and Contact Information */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-6 text-teal-400">E-Mail Removal and Contact Information</h2>
            <div className="bg-teal-900/20 border border-teal-500/30 rounded-lg p-6">
              <p className="text-gray-300 leading-relaxed">
                If for any reason you wish to stop all future communications from ChillFree TV, you may send an e-mail with the words "E-Mail Removal" in the subject line to{' '}
                <a href="mailto:datarequest@chillfree.tv" className="text-teal-400 hover:text-teal-300 underline">
                  datarequest@chillfree.tv
                </a>{' '}
                requesting that your information be permanently removed from any ChillFree TV database. ChillFree TV will send an email confirmation of such removal to you within thirty (30) business days of receipt of your request.
              </p>
            </div>
          </section>

        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsOfUsePage;

